import * as React from 'react'
import { Combobox } from '@base-ui/react/combobox'
import type { PartProps } from '../../../lib/part-props'

interface ComboboxPortalProps extends PartProps<React.ComponentProps<typeof Combobox.Portal>> {}

function ComboboxPortal({ children, ...props }: ComboboxPortalProps) {
  return <Combobox.Portal {...props}>{children}</Combobox.Portal>
}

export { ComboboxPortal }
